import React from "react";

import { ModalProvider } from "shared";

export const ApplicationContext = React.createContext();

export function ApplicationContextProvider({ children }) {
  return (
    <ApplicationContext.Provider>
      <ModalProvider>{children}</ModalProvider>
    </ApplicationContext.Provider>
  );
}
